"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var DropdownMenuPrimitive = _interopRequireWildcard(require("@radix-ui/react-dropdown-menu"));
require("./radix-styles/DropdownMenu.scss");
var _sebikostudioIcons = require("sebikostudio-icons");
var _excluded = ["children"],
  _excluded2 = ["children", "noPadding"],
  _excluded3 = ["children", "hotkey", "icon"],
  _excluded4 = ["children", "hotkey", "icon"],
  _excluded5 = ["children"],
  _excluded6 = ["children", "hotkey", "icon"],
  _excluded7 = ["children"],
  _excluded8 = ["children", "icon"],
  _excluded9 = ["children", "noPadding"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DropdownMenu = DropdownMenuPrimitive.Root;
DropdownMenu.Trigger = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.Trigger, _extends({
    asChild: true,
    ref: ref
  }, props), children);
});
DropdownMenu.Content = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    noPadding = _ref2.noPadding,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var classNames = "DropdownMenuContent".concat(noPadding ? " noPadding" : "");
  return /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.Portal, null, /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.Content, _extends({
    ref: ref,
    sideOffset: 8,
    className: classNames
  }, props), children));
});
DropdownMenu.Item = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    hotkey = _ref3.hotkey,
    Icon = _ref3.icon,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.Item, _extends({
    ref: ref,
    className: "DropdownMenuItem"
  }, props), /*#__PURE__*/_react["default"].createElement("div", {
    className: "LeftSlot"
  }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "LabelSlot"
  }, children), hotkey && /*#__PURE__*/_react["default"].createElement("div", {
    className: "RightSlot"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Hotkey"
  }, /*#__PURE__*/_react["default"].createElement("span", null, hotkey))));
});
DropdownMenu.CheckboxItem = /*#__PURE__*/_react["default"].forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
    hotkey = _ref4.hotkey,
    Icon = _ref4.icon,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.CheckboxItem, _extends({
    ref: ref,
    className: "DropdownMenuCheckboxItem"
  }, props), /*#__PURE__*/_react["default"].createElement("div", {
    className: "LeftSlot"
  }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "LabelSlot"
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "RightSlot"
  }, /*#__PURE__*/_react["default"].createElement(_sebikostudioIcons.CheckIcon, null), hotkey && /*#__PURE__*/_react["default"].createElement("div", {
    className: "Hotkey"
  }, /*#__PURE__*/_react["default"].createElement("span", null, hotkey))));
});
DropdownMenu.RadioGroup = function (_ref5) {
  var children = _ref5.children,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.RadioGroup, props, children);
};
DropdownMenu.RadioItem = /*#__PURE__*/_react["default"].forwardRef(function (_ref6, ref) {
  var children = _ref6.children,
    hotkey = _ref6.hotkey,
    Icon = _ref6.icon,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.RadioItem, _extends({
    ref: ref,
    className: "DropdownMenuRadioItem"
  }, props), /*#__PURE__*/_react["default"].createElement("div", {
    className: "LeftSlot"
  }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "LabelSlot"
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "RightSlot"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "RadioButton"
  }, /*#__PURE__*/_react["default"].createElement("span", null)), hotkey && /*#__PURE__*/_react["default"].createElement("div", {
    className: "Hotkey"
  }, /*#__PURE__*/_react["default"].createElement("span", null, hotkey))));
});
DropdownMenu.Separator = function () {
  return /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.Separator, null);
};
DropdownMenu.Sub = function (_ref7) {
  var children = _ref7.children,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.Sub, props, children);
};
DropdownMenu.SubTrigger = /*#__PURE__*/_react["default"].forwardRef(function (_ref8, ref) {
  var children = _ref8.children,
    Icon = _ref8.icon,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.SubTrigger, _extends({
    ref: ref,
    className: "DropdownMenuSubTrigger",
    asChild: true
  }, props), /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.Item, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "LeftSlot"
  }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "LabelSlot"
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "RightSlot"
  }, /*#__PURE__*/_react["default"].createElement(_sebikostudioIcons.ChevronRightIcon, null))));
});
DropdownMenu.SubContent = /*#__PURE__*/_react["default"].forwardRef(function (_ref9, ref) {
  var children = _ref9.children,
    noPadding = _ref9.noPadding,
    props = _objectWithoutProperties(_ref9, _excluded9);
  var classNames = "DropdownMenuSubContent".concat(noPadding ? " noPadding" : "");
  return /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.Portal, null, /*#__PURE__*/_react["default"].createElement(DropdownMenuPrimitive.SubContent, _extends({
    ref: ref,
    sideOffset: 12,
    className: classNames
  }, props), children));
});
var _default = exports["default"] = DropdownMenu;